// 公共组件本地/云端流程切换
export default {
    'toggleProcess.tips1': 'No network detected. Please connect to the internet and try again!',
    'toggleProcess.tips2': "Failed to retrieve the local domain name. Please confirm the current WiFi is the network's WiFi.",
    'toggleProcess.tips3': 'Are you sure you want to switch versions? Please note that different versions display different pages.' 
}
 